import Image from 'next/image';

import { NextLink } from '@/atoms';

import { formatDateNumeric, getUrlExtension, isPNG } from '@/lib/utils';
import FallBackIMG from '@/assets/images/fallback-product-card.jpg';

import type { FunctionComponent } from 'react';
import type { TypeCardMostViewedProps } from './types';

/**
 * CardMostViewed
 */
export const CardMostViewed: FunctionComponent<TypeCardMostViewedProps> = ({
  className = '',
  image,
  date,
  readingTime,
  title,
  excerpt,
  href,
}: TypeCardMostViewedProps) => {
  const srcWithFallback = image?.src || FallBackIMG.src;
  const objectFit = isPNG(getUrlExtension(srcWithFallback))
    ? 'object-contain'
    : 'object-cover';

  return (
    <NextLink href={href}>
      <a
        className={`flex w-full gap-2 bg-white p-2 outline outline-1 outline-primary-100 ${className}`}
      >
        <Image
          src={srcWithFallback}
          alt={image?.alt || title}
          width={192}
          height={216}
          draggable="false"
          style={{ aspectRatio: '6/7' }}
          className={`h-36 w-32 object-center ${objectFit}`}
        />

        <div className="flex w-full flex-col gap-3 p-1">
          <div className="u-label u-label--overlline flex flex-row justify-between gap-4 text-primary-400">
            <time>{formatDateNumeric(date)}</time>

            {readingTime && <time>{readingTime} MIN</time>}
          </div>

          <div className="flex flex-col gap-1 text-primary-900">
            <h3 className="u-headline u-headline--h4 line-clamp-2">{title}</h3>

            {excerpt && (
              <div className="u-body u-body--xs line-clamp-2">{excerpt}</div>
            )}
          </div>
        </div>
      </a>
    </NextLink>
  );
};
